export default {
      id: "chat-usage",
      viewBox: "0 0 129 113",
      url: __webpack_public_path__ + "icons-sprite.ef97e87.svg#chat-usage",
      toString: function () {
        return this.url;
      }
    }